import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Seo from "../components/Seo";
import { addToCart } from "../lib/cart";
import { api } from "../lib/api";
import { Currency, formatMoney } from "../lib/currency";
import { t } from "../lib/i18n";
import { sampleProducts } from "./_shared";

export default function ProductDetail({ currency }: { currency: Currency }) {
  const { slug, lang = "en" } = useParams();
  const fallback = sampleProducts.find((p) => p.slug === slug) || sampleProducts[0];
  const [product, setProduct] = useState<any>(fallback);
  useEffect(() => { if (slug) api<any>(`/api/products/${slug}/detail`).then((p) => { if (p) setProduct(p); }).catch(() => undefined); }, [slug]);
  const image = product.image || product.main_image || product.images?.[0]?.url || "/placeholder.webp";
  return (
    <>
      <Seo title={product.seo_title || product.title} description={product.seo_description || product.description || `Buy ${product.title} from SellerSupply Shop.`} image={image} />
      <section className="container-page grid gap-8 py-8 md:grid-cols-2">
        <div className="space-y-3">
          <img src={image} className="aspect-square w-full rounded-[28px] object-cover shadow-[0_24px_70px_rgba(15,23,42,0.12)]" />
          <div className="grid grid-cols-4 gap-3">{(product.images || []).slice(0,4).map((img: any) => <img key={img.id || img.url} src={img.url} className="aspect-square rounded-2xl object-cover" />)}</div>
        </div>
        <div>
          <p className="text-sm font-semibold uppercase text-[#C89B5C]">{product.category || "Featured"}</p>
          <h1 className="mt-2 text-4xl font-black">{product.title}</h1>
          <p className="mt-3 text-slate-600">{product.subtitle}</p>
          <p className="mt-4 text-2xl font-bold">{formatMoney(Number(product.price || 0), currency)}</p>
          <p className="mt-4 leading-7 text-slate-600">{product.description || (lang === "zh" ? "该商品支持手动付款审核和简洁结账流程。" : "This product supports manual payment review and a simple checkout flow.")}</p>
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <button className="btn-primary w-full" onClick={() => addToCart({ productId: product.id, slug: product.slug, title: product.title, image, price: Number(product.price || 0), quantity: 1 })}>{t(lang, "addToCart")}</button>
            <button className="btn-secondary w-full">♡ {t(lang, "wishlist")}</button>
          </div>
          <div className="mt-8 rounded-[24px] bg-white p-5 shadow-[0_18px_45px_rgba(15,23,42,0.07)]">
            <h2 className="font-bold">{lang === "zh" ? "商品详情" : "Product Details"}</h2>
            <div className="mt-3 text-sm leading-7 text-slate-600" dangerouslySetInnerHTML={{ __html: product.detail_html || product.description || "" }} />
          </div>
        </div>
      </section>
    </>
  );
}
